import Api from '@/services/Api'

export default class {
  getStatus () {
    return Api().get("admin/status")
  }

  listDevices () {
    return Api().get("admin/device")
  }

  createDevices (devices) {
    return Api().request({
      method: 'post',
      url: '/admin/device',
      data: devices,
    });
  }

  resetDeviceOwnership(deviceID) {
    return Api().get("admin/device/" + deviceID + "/reset-ownership")
  }

  setDeviceNonBillable(deviceID, value) {
    let formData = new FormData()
    formData.append('non-billable', value);
    return Api().post('admin/device/' + deviceID + '/set-non-billable', formData)
  }
  shareDevice(deviceID) {
    return Api().get("admin/device/" + deviceID + "/share")
  }
  listCustomers() {
    return Api().get("v2/admin/customer")
  }
  deleteCustomer(id) {
    return Api().delete("v2/admin/customer/" + id)
  }
  readSIM(icc, simProvider) {
    return Api().get("admin/gsm/" + simProvider + "/" + icc)
  }
  deleteDevice(deviceID) {
    return Api().delete("admin/device/" + deviceID)
  }
  loadCache() {
    return Api().get("v2/admin/cache")
  }
  flushCache(reload) {
    return Api().get("v2/admin/cache/flush" + (reload ? "?reload=true" : ""))
  }
  listRegistrations() {
    return Api().get("admin/registration")
  }
  listActivationCodeBatches() {
    return Api().get("admin/activation-code-batch")
  }
  listActivationCodes(batch) {
    return Api().get("admin/activation-code-batch/" + batch)
  }
  generateActivationCodeBatch(size, name) {
    let formData = new FormData()
    formData.append('size', size);
    formData.append('name', name)
    return Api().post("admin/activation-code-batch", formData)
  }
  downloadActivationCodeBatch(batch) {
    return this.downloadFile(`admin/activation-code-batch/${batch}/download`, `${batch}-codes.zip`)
  }
  sendSMS(deviceID, messageText) {
    let formData = new FormData()
    formData.append('message-text', messageText)
    return Api().post('admin/device/' + deviceID + '/send-sms', formData)
  }
  hourStats() {
    return Api().get("/v2/admin/hour-stats")
  }

  exportDeviceInfluxes(deviceID) {
    return this.downloadFile(`v2/admin/device/${deviceID}/export/influx`, `${deviceID}.csv`)
  }

  exportGPX(deviceID) {
    return this.downloadFile(`v2/admin/device/${deviceID}/export/gpx`, `${deviceID}.gpx`)
  }

  downloadFile(url, fileName) {
    return Api().request({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName);
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    });
  }
}
